import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getNutritionInfoRoute } from '@services/routes.service';
import Card from '@components/Card';
import SimpleButton, { SIZE } from '@components/SimpleButton';

const Container = styled(Card)`
  justify-content: space-between;
`;

const Subtitle = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.mediumBold}
  color: ${({ theme }) => theme.colors.textPrimary};
  display: inline;
  margin: auto 0;
`;

function NutritionalTable({ pushPage, gtin }) {
  return (
    <Container>
      <Subtitle>Información nutricional</Subtitle>
      <SimpleButton
        onClick={() => pushPage(getNutritionInfoRoute(gtin))}
        label="Ver información"
        size={SIZE.SMALL}
      />
    </Container>
  );
}

NutritionalTable.propTypes = {
  gtin: PropTypes.string,
  pushPage: PropTypes.func,
};

export default NutritionalTable;
